import { useRef, useEffect } from 'react';

const DateInput = ({label, fieldName, isRequired, formData, setFormData, setValidationErrors, validStartDate, validEndDate}) => {
    const part1Ref = useRef();
    const part2Ref = useRef();
    const part3Ref = useRef();
    const dateErrorRef = useRef();

    useEffect(() => {
        part1Ref.current.value = formData[fieldName] ? formData[fieldName].substr(0, 2) : '';
        part2Ref.current.value = formData[fieldName] ? formData[fieldName].substr(2, 2) : '';
        part3Ref.current.value = formData[fieldName] ? formData[fieldName].substr(4, 4) : '';
        }, [formData, fieldName]);
  
    function _handleChange () {
        setFormData((prevFormData) => ({ ...prevFormData, [fieldName]: part1Ref.current.value + part2Ref.current.value + part3Ref.current.value }));
    };

    function _handleKeyUp(partRef) {
        if(partRef.keyCode) {
            // 'delete' and input is empty, then go to previous input
            if (partRef.keyCode === 8 && !partRef.target.value) {
                var previous = partRef.target.previousElementSibling;
                if (previous && previous.tagName.toLowerCase() === 'input') {
                  previous.focus();
                }
            }

            // if tab, left, or right just exit
            if (partRef.keyCode === 9 || partRef.keyCode === 16 ||
                (partRef.keyCode >= 35 && partRef.keyCode <= 40)) {
                return;
            }

            var maxLength = parseInt(partRef.target.attributes['maxlength'].value, 10);
            var myLength = partRef.target.value.length;
            if (myLength >= maxLength) {
                var next = partRef.target.nextElementSibling;
                if (next && next.tagName.toLowerCase() === 'input') {
                    next.focus();
                }
            }

            var nums = part1Ref.current.value + part2Ref.current.value + part3Ref.current.value;
            nums = nums.replace(/\D/g,'');

            var month = parseInt(part1Ref.current.value, 10);
            month = Number.isNaN(month) ? 0 : month;
            var day = parseInt(part2Ref.current.value, 10);
            day = Number.isNaN(day) ? 0 : day;
            var year = parseInt(part3Ref.current.value, 10);
            year = Number.isNaN(year) ? 0 : year;

            var date = new Date(year, month-1, day);
            var startDt = validStartDate ? new Date(validStartDate) : undefined;
            var endDt = validEndDate ? new Date(validEndDate) : undefined;
            if (startDt === undefined) startDt = new Date(1900, 0, 1);
            if (endDt === undefined) endDt = new Date(); //today
            
            if (nums < 8 || month < 1 || month > 12 || day < 1 || day > 31 
                || date < startDt || date > endDt) {
                dateErrorRef.current.style.display = 'block';
                setValidationErrors(errors => ({ ...errors, [fieldName]: 'Invalid date' }));
            } 
            else {
                dateErrorRef.current.style.display = 'none';
                setValidationErrors(errors => {
                    const {[fieldName]: _, ...rest} = errors;
                    return rest;
                })
            }
        }
    };
  
    function renderPart(partRef, length, placeholder) {
        var style = {
            maxWidth: (60 + length * 12),
            display: 'inline-block'
        };
  
        return (
          <input
            type='number' className='QuestionInput'
            style={style} 
            ref={partRef} maxLength={length}
            onChange={_handleChange}
            placeholder={placeholder}
            onKeyUp={_handleKeyUp} required={isRequired} />
        );
    };
 
    return (
    <div className="QuestionBox">
        <div className="QuestionLabel">{label}</div>
        <div>{renderPart(part1Ref, 2, 'mm')} / {renderPart(part2Ref, 2, 'dd')} / {renderPart(part3Ref, 4, 'yyyy')}</div>
        <div ref={dateErrorRef} className='text_error' style={{display: 'none'}}>Invalid date</div>
    </div>
    );
};

export default DateInput;
